import * as React from 'react';
import { connect } from 'react-redux';
import { fetchPublicacion, editPublicacion } from '../../../../actions/publicacionesActions';
import DrawAndDrop from './DrawAndDropImages';
import ImageUploader from './ImageUploader';

class Imagenes extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            imagenes: []
        }
    }

    //componentDidMount() {
    //    if (!this.state.imagenes.length) {
    //        this.setState({ imagenes: this.props.publicacion.imagenes });
    //    }
    //}

    render() {
        return (
           
            <div>
                 <ImageUploader /> 
                {/* <DrawAndDrop isNewPublicacion={this.props.inCreate} />  */}
            </div>
        )
    }
}

const mapStateToProps = state => ({
    publicacion: state.publicaciones.publicacion,
});

export default connect(mapStateToProps, { fetchPublicacion, editPublicacion })(Imagenes);